module.exports = __webpack_public_path__ + "static/img/3254_phase_function_Paper_Points.a365d22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3254_phase_function_Paper_Points.png
// module id = sojD
// module chunks = 0